export default __webpack_public_path__ + "static/media/undefined.f7d86848.svg";